// extracted by mini-css-extract-plugin
export default {"cardLabel":"CardSection_cardLabel__wZ30T","cardElement":"CardSection_cardElement__D5z0i"};